module.exports = __webpack_public_path__ + "img/section_1.fc9c4f7b.jpg";